/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M17.5677 6.637c-.5167-2.7669-3.0076-4.887-6.026-4.887-3.4 0-6.125 2.6856-6.125 5.9605 0 .1592.0064.3168.0189.4726l.0538.669-.659.1275C3.1177 9.3106 1.75 10.928 1.75 13.0789c0 .7016.1991 1.4156.5565 2.0553C3.007 16.388 4.245 17.25 5.5833 17.25H9.5a.75.75 0 0 1 0 1.5H5.5833c-2.0003 0-3.684-1.2693-4.5863-2.8842-.4702-.8417-.747-1.8056-.747-2.7869 0-2.5499 1.5052-4.6899 3.6668-5.4077C3.9384 3.5522 7.361.25 11.5417.25c3.5561 0 6.5595 2.386 7.3947 5.6342 2.7721.798 4.8136 3.3064 4.8136 6.3a6.432 6.432 0 0 1-.8415 3.1862.75.75 0 0 1-1.0226.2817.7498.7498 0 0 1-.2817-1.0225 4.9323 4.9323 0 0 0 .6458-2.4454c0-2.415-1.7435-4.4544-4.0997-4.951l-.4905-.1033-.0921-.4928Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Zm0-1.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5ZM24 23.7572c0-.5131-.045-1.0144-.1308-1.4996C23.2387 18.691 20.4029 16 17 16c-3.4029 0-6.2387 2.691-6.8692 6.2576A8.6084 8.6084 0 0 0 10 23.7572h14Zm-12.3434-1.4996h10.6868C21.7403 19.4406 19.4771 17.5 17 17.5s-4.7403 1.9406-5.3434 4.7576Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuConsumerIds'
);
